import {
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Transition } from '../../components/Transition';
import DeliverySlotsCalendar from './DeliverySlotsCalendar';

interface Props {
  open: boolean;
  onClose: () => void;
  refreshKey?: number;
  onEditSlotsClick?: () => void;
}

const DeliverySlotsCalendarDialog = ({
  open,
  onClose,
  refreshKey,
  onEditSlotsClick,
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth='lg'
    TransitionComponent={Transition}
    sx={{
      '& .MuiDialog-paper': {
        m: { xs: 1.5, sm: 2 },
        width: { xs: 'calc(100% - 24px)', sm: 'min(1040px, calc(100% - 48px))' },
        maxWidth: '1040px !important',
        maxHeight: { xs: 'calc(100% - 24px)', sm: '86vh' },
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    <DialogContent
      sx={{
        position: 'relative',
        px: { xs: 1.5, sm: 2.25 },
        pt: { xs: 1.75, sm: 2 },
        pb: 2,
        overflowY: 'auto',
        minHeight: 0,
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}
        aria-label='Close calendar'
      >
        <CloseIcon />
      </IconButton>
      <DeliverySlotsCalendar
        embedded
        headerTitle='Capacity Calendar'
        refreshKey={refreshKey}
        onEditSlotsClick={onEditSlotsClick}
      />
    </DialogContent>
  </Dialog>
);

export default DeliverySlotsCalendarDialog;
